import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';

export const adminGuard: CanActivateFn = async (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  try {
    await auth.authStateReady();
    const user = auth.currentUser;

    // Sin sesión: sí corresponde ir a login.
    if (!user) {
      return router.createUrlTree(['/auth'], {
        queryParams: { returnUrl: state.url },
      });
    }

    let tokendata = await user.getIdTokenResult();
    // El token se cachea hasta 1h: si no trae el claim, reintenta con refresh
    // forzado antes de negar (los claims pueden haberse seteado después del login).
    if (!tokendata?.claims['superadmin'] && !tokendata?.claims['admin']) {
      tokendata = await user.getIdTokenResult(true);
    }

    if (!tokendata?.claims['superadmin'] && !tokendata?.claims['admin']) {
      // Hay sesión válida, solo falta el permiso: nunca redirigir a /auth,
      // porque authRedirectGuard reenvía de vuelta acá y se genera un bucle.
      return router.createUrlTree(['/boards'], {
        queryParams: { access_denied: 'admin' },
      });
    }

    return true;

  } catch (error) {
    console.error('Error en adminGuard', error);
    return router.createUrlTree(['/boards'], {
      queryParams: { access_denied: 'admin' },
    });
  }
};
